(function () {
  if (window.__guidedFlowInit) return;
  window.__guidedFlowInit = true;

  var ADVANCE_EVENT = 'guidedProcess:advance';

  function init() {
    var steps = Array.prototype.slice.call(document.querySelectorAll('.guided-step'));

    steps.forEach(function (step, i) {
      step.classList.add(i === 0 ? 'is-visible' : 'is-pending');
    });

    window.addEventListener(ADVANCE_EVENT, function () {
      var next = steps.find(function (step) {
        return step.classList.contains('is-pending');
      });
      if (!next) return;
      next.classList.remove('is-pending');
      next.classList.add('is-visible');
      window.requestAnimationFrame(function () {
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();